// Unpublished Work © 2021-2025 Deere & Company.

import {
    RESET_CUSTOMER_PROFILE,
    SET_PROFILE_DATA,
    FILTER_CONTACTS_BY_CONTACT_ID
} from '../../action-list';
import {Customer} from '../../state/struct/customer';

const setProfileData = (state, action) => action.customerProfile.contacts.map((contact) => Customer(contact));

const resetCustomerProfile = () => [];

const filterContactsByContactId = (state, action) => state.filter((contact) => action.contactId !== contact.contactId);

export const contacts = (state = [], action = {}) => {
    const actionHandlers = {
        [RESET_CUSTOMER_PROFILE]: resetCustomerProfile,
        [SET_PROFILE_DATA]: setProfileData,
        [FILTER_CONTACTS_BY_CONTACT_ID]: filterContactsByContactId
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
